// gimme: conversations-inbox-ui 06/02/2020 5f1e15ece5fe518f7ad7313590340d8fe6192284
'use es6';

import get from 'transmute/get';
export const getTypingIndicators = get('typingIndicators');